<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="view">
            <defs>
                <path id="aezdfbecna" d="M19.9 11.71c-.028-.057-.724-1.436-2.024-2.826-.772-.826-1.601-1.486-2.463-1.962-1.1-.608-2.253-.916-3.429-.916-1.175 0-2.329.308-3.428.916-.862.476-1.69 1.136-2.463 1.962-1.3 1.39-1.996 2.769-2.025 2.827-.09.182-.09.396 0 .578.029.058.724 1.437 2.025 2.827.772.826 1.601 1.486 2.463 1.962 1.1.608 2.253.916 3.428.916 1.176 0 2.33-.308 3.43-.916.86-.476 1.69-1.136 2.462-1.962 1.3-1.39 1.996-2.769 2.025-2.827.09-.182.09-.396 0-.578zm-7.916 4.992c-1.742 0-3.4-.823-4.927-2.446C6.213 13.36 5.64 12.45 5.38 12c.615-1.065 2.98-4.702 6.603-4.702 1.743 0 3.4.823 4.928 2.446.844.896 1.416 1.806 1.676 2.256-.615 1.065-2.98 4.702-6.604 4.702zm0-7.354c-1.459 0-2.646 1.19-2.646 2.652 0 1.462 1.187 2.652 2.646 2.652 1.46 0 2.647-1.19 2.647-2.652 0-1.462-1.187-2.652-2.647-2.652zm0 4.011c-.748 0-1.356-.61-1.356-1.359 0-.75.608-1.36 1.356-1.36.748 0 1.357.61 1.357 1.36 0 .75-.609 1.36-1.357 1.36z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="tkuw93ep1b" fill="#fff">
                    <use xlink:href="#aezdfbecna"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#tkuw93ep1b)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-view',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>